module.exports = __webpack_public_path__ + "img/quick_massage.97826308.png";